// extracted by mini-css-extract-plugin
export var actions = "_m7-5";
export var assistantBubble = "_m7-3";
export var assistantRow = "_m7-6";
export var bubble = "_m7-0";
export var humanAvatar = "_m7-4";
export var inlineToolCard = "_m7-1";
export var userBubble = "_m7-2";